import React, { useContext } from 'react';
import _inheritsLoose from '@babel/runtime/helpers/inheritsLoose';
import classNames from 'classnames';
import { I as IMAGE_TYPE, R as RICOS_DEFAULTS } from './viewer-loadable2.js';
import { uniqueId, includes, get, isFunction, isNumber, upperFirst, camelCase } from 'lodash';
import { addAnchorTagToUrl, anchorScroll, isSSR } from 'wix-rich-content-common';
import { initCustomElement, Image as Image$2 } from '@wix/image';
import { s as styles$1, e as expand, I as InPluginInput } from './image-viewer.rtlignore.js';
import { RicosViewerContext, RicosContext } from 'ricos-context';
import { PluginContainerData_Width_Type, PluginContainerData_Alignment } from 'ricos-schema';
import '@loadable/component';
import 'ricos-types';

function _createForOfIteratorHelperLoose$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }
function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$1(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$1) {
    for (var _iterator = _createForOfIteratorHelperLoose$1(__getOwnPropSymbols$1(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
    }
  }
  return a;
};
initCustomElement();
var IMAGE_FALLBACK_WIDTH = 300;
var getImageSrc = function getImageSrc(src, customGetImageUrl) {
  if (src == null ? void 0 : src.url) {
    return src.url;
  } else if (src == null ? void 0 : src.id) {
    if (customGetImageUrl) {
      return customGetImageUrl({
        file_name: src.id
      });
    }
    return src.id;
  }
  return "";
};
var ImageViewer = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ImageViewer, _React$Component);
  function ImageViewer(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.handleExpand = function (e) {
      var _a;
      e.preventDefault();
      var _this$props = _this.props,
        onExpand = _this$props.settings.onExpand,
        _this$props$helpers = _this$props.helpers,
        helpers = _this$props$helpers === void 0 ? {} : _this$props$helpers;
      (_a = helpers.onViewerAction) == null ? void 0 : _a.call(helpers, IMAGE_TYPE, "Click", "expand_image");
      _this.hasExpand() && (onExpand == null ? void 0 : onExpand(_this.props.node.id));
    };
    _this.scrollToAnchor = function (e) {
      var _this$props2 = _this.props,
        _this$props2$node$ima = _this$props2.node.imageData;
      _this$props2$node$ima = _this$props2$node$ima === void 0 ? {} : _this$props2$node$ima;
      var link = _this$props2$node$ima.link,
        customAnchorScroll = _this$props2.customAnchorScroll;
      var anchor = link == null ? void 0 : link.anchor;
      if (customAnchorScroll) {
        customAnchorScroll(e, anchor);
      } else {
        var anchorString = "viewer-" + anchor;
        var element = document.getElementById(anchorString);
        addAnchorTagToUrl(anchorString);
        anchorScroll(element);
      }
    };
    _this.hasLink = function () {
      var _a, _b;
      return (_b = (_a = _this.props.node.imageData) == null ? void 0 : _a.link) == null ? void 0 : _b.url;
    };
    _this.hasAnchor = function () {
      var _a, _b;
      return (_b = (_a = _this.props.node.imageData) == null ? void 0 : _a.link) == null ? void 0 : _b.anchor;
    };
    _this.onKeyDown = function (e) {
      if (e.key === "Enter" || e.key === " ") {
        _this.handleClick(e);
      }
    };
    _this.handleClick = function (e) {
      if (_this.hasLink()) {
        return null;
      } else if (_this.hasAnchor()) {
        e.preventDefault();
        e.stopPropagation();
        _this.scrollToAnchor(e);
      } else {
        _this.handleExpand(e);
      }
    };
    _this.handleContextMenu = function (e) {
      var _this$props$node$imag = _this.props.node.imageData;
      _this$props$node$imag = _this$props$node$imag === void 0 ? {} : _this$props$node$imag;
      var _this$props$node$imag2 = _this$props$node$imag.disableDownload,
        disableDownload = _this$props$node$imag2 === void 0 ? false : _this$props$node$imag2;
      return disableDownload && e.preventDefault();
    };
    _this.hasExpand = function () {
      var _this$props3 = _this.props,
        imageData = _this$props3.node.imageData,
        settings = _this$props3.settings;
      var disableExpand = false;
      if ((imageData == null ? void 0 : imageData.disableExpand) !== void 0) {
        disableExpand = imageData.disableExpand;
      } else if (settings.disableExpand !== void 0) {
        disableExpand = settings.disableExpand;
      }
      return !disableExpand && settings.onExpand;
    };
    _this.renderExpandIcon = function () {
      return /* @__PURE__ */React.createElement("div", {
        className: styles$1.expandContainer
      }, /* @__PURE__ */React.createElement(expand, {
        className: styles$1.expandIcon,
        onClick: _this.handleExpand
      }));
    };
    _this.getImgSize = function (imgSrc) {
      var newImg = new Image();
      newImg.onload = function () {
        return _this.setState({
          dimensions: {
            width: newImg.width,
            height: newImg.height
          }
        });
      };
      newImg.src = imgSrc;
    };
    _this._id = uniqueId("new-image");
    return _this;
  }
  var _proto = ImageViewer.prototype;
  _proto.getImageDataUrl = function getImageDataUrl() {
    return this.props.dataUrl ? this.props.dataUrl : null;
  };
  _proto.renderCaption = function renderCaption(caption) {
    var _this$props4 = this.props,
      onCaptionChange = _this$props4.onCaptionChange,
      setFocusToBlock = _this$props4.setFocusToBlock;
    var classes = classNames(styles$1.imageCaption, this.hasLink() && styles$1.link);
    return onCaptionChange ? /* @__PURE__ */React.createElement(InPluginInput, {
      className: classes,
      value: caption,
      onChange: onCaptionChange,
      setFocusToBlock: setFocusToBlock
    }) : /* @__PURE__ */React.createElement("span", {
      dir: "auto",
      className: classes
    }, caption);
  };
  _proto.shouldRenderCaption = function shouldRenderCaption() {
    var _a, _b, _c, _d;
    var _this$props5 = this.props,
      settings = _this$props5.settings,
      node = _this$props5.node,
      defaultCaption = _this$props5.defaultCaption;
    var caption = (_a = node.imageData) == null ? void 0 : _a.caption;
    if (includes(get(settings, "toolbar.hidden"), "settings")) {
      return false;
    }
    if (!caption || caption === defaultCaption) {
      return false;
    }
    var _ref = node.imageData || RICOS_DEFAULTS,
      containerData = _ref.containerData;
    if (((_b = containerData == null ? void 0 : containerData.width) == null ? void 0 : _b.size) === "ORIGINAL" && ((_d = (_c = node.imageData) == null ? void 0 : _c.image) == null ? void 0 : _d.width)) {
      return node.imageData.image.width >= 350;
    }
    return true;
  }
  // eslint-disable-next-line complexity
  ;
  _proto.render = function render() {
    var _classNames;
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    var _this$props6 = this.props,
      node = _this$props6.node,
      className = _this$props6.className,
      settings = _this$props6.settings,
      setComponentUrl = _this$props6.setComponentUrl,
      helpers = _this$props6.helpers,
      isMobile = _this$props6.isMobile,
      seoMode = _this$props6.seoMode,
      accessibilityProps = _this$props6.accessibilityProps,
      onCaptionChange = _this$props6.onCaptionChange;
    var _ref2 = node.imageData || RICOS_DEFAULTS,
      containerData = _ref2.containerData;
    var _ref3 = node.imageData || {},
      image = _ref3.image,
      altText = _ref3.altText;
    var _ref4 = image || {},
      src = _ref4.src,
      width = _ref4.width,
      height = _ref4.height;
    var itemClassName = classNames(styles$1.imageWrapper, styles$1.imageRatio, className, (_classNames = {}, _classNames[styles$1.pointer] = this.hasExpand(), _classNames));
    var imageSrc = this.getImageDataUrl() || getImageSrc(src, helpers == null ? void 0 : helpers.getImageUrl);
    var imageProps = {};
    if (src && settings && settings.imageProps) {
      imageProps = isFunction(settings.imageProps) ? settings.imageProps({
        url: src.url,
        file_name: src.id,
        width: width,
        height: height
      }) : settings.imageProps;
    }
    var socialAttrs = {};
    ["data-pin-nopin", "data-pin-url", "data-pin-media"].forEach(function (attr) {
      return imageProps[attr] && (socialAttrs[attr] = imageProps[attr]);
    });
    setComponentUrl == null ? void 0 : setComponentUrl(imageSrc);
    var usePredefinedWidth = ((containerData == null ? void 0 : containerData.alignment) === "LEFT" || (containerData == null ? void 0 : containerData.alignment) === "RIGHT") && !((_a = containerData.width) == null ? void 0 : _a.custom) && ((_b = containerData.width) == null ? void 0 : _b.size) !== "SMALL" && ((_c = containerData.width) == null ? void 0 : _c.size) !== "ORIGINAL" && !isMobile;
    var dim = {
      width: width || ((_d = containerData == null ? void 0 : containerData.width) == null ? void 0 : _d.custom) || ((_e = this.state) == null ? void 0 : _e.dimensions.width),
      height: height || ((_f = containerData == null ? void 0 : containerData.height) == null ? void 0 : _f.custom) || ((_g = this.state) == null ? void 0 : _g.dimensions.height)
    };
    var isDimensionsExists = dim.width && dim.height;
    if (!isDimensionsExists && !isSSR()) {
      this.getImgSize(imageSrc);
    }
    var customWidthStyle = ((_h = containerData == null ? void 0 : containerData.width) == null ? void 0 : _h.size) === "ORIGINAL" || isMobile && (((_i = containerData == null ? void 0 : containerData.width) == null ? void 0 : _i.custom) || 0) > 150 ? {
      width: width + "px",
      maxWidth: "100%"
    } : {};
    var isEditor = !!onCaptionChange;
    return /* @__PURE__ */React.createElement("div", __spreadValues$1({
      "data-hook": "imageViewer",
      className: styles$1.imageContainer,
      onContextMenu: this.handleContextMenu,
      onKeyDown: this.onKeyDown
    }, accessibilityProps), /* @__PURE__ */React.createElement("div", {
      className: itemClassName,
      id: this._id,
      "aria-label": altText,
      onClick: this.handleClick,
      onKeyDown: this.onKeyDown,
      style: __spreadValues$1(__spreadValues$1({
        "--dim-height": dim.height,
        "--dim-width": dim.width
      }, usePredefinedWidth && {
        width: IMAGE_FALLBACK_WIDTH + "px"
      }), customWidthStyle)
    }, isDimensionsExists && /* @__PURE__ */React.createElement(Image$2, __spreadValues$1({
      id: imageSrc,
      containerId: this._id,
      displayMode: "fill",
      width: dim.width,
      height: dim.height,
      uri: imageSrc,
      alt: altText || "",
      socialAttrs: socialAttrs,
      isSEOBot: !!seoMode,
      imageStyles: {
        maxWidth: "100%"
      }
    }, !isEditor ? {
      placeholderTransition: seoMode ? void 0 : "blur",
      shouldUseLQIP: !settings.disableTransition
    } : {})), this.hasExpand() && this.renderExpandIcon()), this.shouldRenderCaption() && this.renderCaption((_j = node.imageData) == null ? void 0 : _j.caption));
  };
  return ImageViewer;
}(React.Component);

var styles = {"alignLeft":"E1Zu8","textWrapNowrap":"evUvX","alignRight":"nJeun","alignCenter":"TiVZ5","sizeFullWidth":"ODVsv","renderedInTable":"ip-V4","sizeOriginal":"sG8EG","sizeContent":"_3CvwX","sizeSmall":"_0VsbP","sizeSmallCenter":"_2n8yo","flex":"d4RUW"};

var shouldDisableStyles = function shouldDisableStyles(node, isMobile) {
  var _a;
  var _ref = ((_a = node.imageData) == null ? void 0 : _a.containerData) || {},
    _ref$width = _ref.width;
  _ref$width = _ref$width === void 0 ? {} : _ref$width;
  var _ref$width$custom = _ref$width.custom,
    custom = _ref$width$custom === void 0 ? void 0 : _ref$width$custom;
  if (isNumber(custom) && custom <= 150) {
    return false;
  }
  return isMobile;
};
var alignmentClassName = function alignmentClassName(node, isMobile) {
  var _a, _b;
  var _ref2 = ((_a = node.imageData) == null ? void 0 : _a.containerData) || {},
    alignment = _ref2.alignment,
    width = _ref2.width;
  if (!alignment || shouldDisableStyles(node, isMobile) && (width == null ? void 0 : width.size) !== PluginContainerData_Width_Type.ORIGINAL) {
    return "";
  }
  var align = alignment;
  if ((width == null ? void 0 : width.size) === PluginContainerData_Width_Type.ORIGINAL && alignment !== PluginContainerData_Alignment.CENTER) {
    var _ref3 = ((_b = node.imageData) == null ? void 0 : _b.image) || {},
      width2 = _ref3.width;
    if (isNumber(width2) && width2 > 350) {
      align = PluginContainerData_Alignment.CENTER;
    }
  }
  return styles["align" + upperFirst(align.toLowerCase())];
};
var sizeClassName = function sizeClassName(node, isMobile) {
  var _a;
  var _ref4 = ((_a = node.imageData) == null ? void 0 : _a.containerData) || {},
    width = _ref4.width;
  if (!(width == null ? void 0 : width.size) || isMobile && (width == null ? void 0 : width.size) === PluginContainerData_Width_Type.ORIGINAL) {
    return "";
  }
  return shouldDisableStyles(node, isMobile) || (width == null ? void 0 : width.size) === PluginContainerData_Width_Type.FULL_WIDTH ? styles.sizeFullWidth : styles["size" + upperFirst(camelCase(width.size.toLowerCase()))];
};
var textWrapClassName = function textWrapClassName(node) {
  var _a;
  var _ref5 = ((_a = node.imageData) == null ? void 0 : _a.containerData) || {},
    textWrap = _ref5.textWrap;
  if (textWrap) {
    return "";
  }
  return styles.textWrapNowrap;
};

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }
  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }
  return target;
};
var Image$1 = function Image(_ref) {
  var node = _ref.node,
    nodeIndex = _ref.nodeIndex,
    NodeViewContainer = _ref.NodeViewContainer;
  var _useContext = useContext(RicosViewerContext),
    config = _useContext.config,
    seoMode = _useContext.seoMode,
    helpers = _useContext.helpers;
  var _useContext2 = useContext(RicosContext),
    isMobile = _useContext2.isMobile,
    experiments = _useContext2.experiments,
    t = _useContext2.t;
  var settings = config[IMAGE_TYPE];
  var hasLink = function hasLink() {
    var _a, _b, _c, _d;
    return ((_b = (_a = node.imageData) == null ? void 0 : _a.link) == null ? void 0 : _b.url) || ((_d = (_c = node.imageData) == null ? void 0 : _c.link) == null ? void 0 : _d.anchor);
  };
  var hasExpandMode = function hasExpandMode() {
    var _a;
    return !(settings.disableExpand || ((_a = node.imageData) == null ? void 0 : _a.disableExpand));
  };
  var accessibilityProps = hasLink() || hasExpandMode() ? {
    role: "button",
    tabIndex: 0
  } : {};
  return /* @__PURE__ */React.createElement(NodeViewContainer, {
    node: node,
    nodeIndex: nodeIndex,
    customClassNames: {
      alignment: alignmentClassName(node, isMobile),
      size: sizeClassName(node, isMobile),
      textWrap: textWrapClassName(node)
    }
  }, /* @__PURE__ */React.createElement(ImageViewer, {
    node: node,
    settings: settings,
    seoMode: seoMode,
    helpers: helpers,
    accessibilityProps: accessibilityProps,
    isMobile: isMobile,
    experiments: experiments,
    defaultCaption: t("ImageViewer_Caption")
  }));
};
var ImageRenderer = function ImageRenderer(_a) {
  var _b = _a,
    node = _b.node,
    props = __objRest(_b, ["node"]);
  return /* @__PURE__ */React.createElement(Image$1, __spreadValues({
    key: node.id,
    node: node
  }, props));
};

export { ImageRenderer as default };

import 'wix-rich-content-plugin-image/dist/loadable/viewer/es/styles.viewer.min.global.css'